<template>
  <form id="lembreteForm" @submit.prevent="submit" class="ajax_off">
    <div class="form-group">
      <textarea id="lembrete" name="lembrete" class="form-control" style="min-height: 300px"
        v-model="lembrete"></textarea>
    </div>
    <button type="button" class="btn btn-danger reset" @click.prevent="lembrete = null">
      <i class="fa fa-eraser"></i> Apagar
    </button>
  </form>
</template>

<script>
export default {
  props: {
    parent_name: String,
    parent_id: Number,
  },
  data() {
    return {
      lembrete: null,
    };
  },
  created() {
    this.getLembrete();
  },
  methods: {
    async submit() {
      const result = await this.$api.post("lembrete", {
        parent_name: this.parent_name,
        parent_id: this.parent_id,
        lembrete: this.lembrete,
      });

      this.$emit("updated", result.data);
      this.$bvModal.hide('lembrete');
    },
    async getLembrete() {
      const result = await this.$api.get(
        `lembrete/${this.parent_name}/${this.parent_id}`
      );
      this.lembrete = result.data.lembrete;
    },
  },
};
</script>